













































import { Vue, Component, Prop } from "vue-property-decorator";

// Component
import Treeselect from "@riophae/vue-treeselect";

// Treeselect Styles
import "@riophae/vue-treeselect/dist/vue-treeselect.css";

// Types
import { ICurrency } from "@/models/constants";

export enum CURRENCY_LABEL {
  CODE_AND_NAME = "code-and-name",
  CODE = "code",
  NAME = "name"
}

@Component({
  components: {
    Treeselect
  }
})
export default class SelectProductCurrencyModal extends Vue {
  @Prop({ required: true })
  public currencies!: ICurrency[];

  @Prop({ required: true })
  public usedCurrenciesIds!: ICurrency["id"][];

  @Prop({ default: false })
  public isMultiple!: boolean;

  @Prop({ default: CURRENCY_LABEL.CODE_AND_NAME })
  public labelType!: CURRENCY_LABEL;

  public selectedCurrenciesIds: ICurrency["id"][] = [];

  public async created() {
    this.selectedCurrenciesIds = this.usedCurrenciesIds;
  }

  public get allCurrencies() {
    return this.$_.map(this.currencies, currency => {
      return this.$_.merge(currency, {
        isDisabled: this.isSelected(currency.id),
        label: `${currency.code} ${currency.name}`
      });
    });
  }

  public get formIsDisabled() {
    return this.$_.isEqual(
      this.selectedCurrenciesIds.sort(),
      this.usedCurrenciesIds.sort()
    );
  }

  public isSelected(currencyId: ICurrency["id"]) {
    return !!this.$_.find(
      this.usedCurrenciesIds,
      usedCurrencyId => usedCurrencyId === currencyId
    );
  }

  public saveCurrencies() {
    this.$emit(
      "success",
      this.$_.filter(
        this.selectedCurrenciesIds,
        selectedCurrencyId =>
          !this.$_.find(
            this.usedCurrenciesIds,
            usedCurrencyId => usedCurrencyId === selectedCurrencyId
          )
      )
    );
    this.$emit("close");
  }

  public getOptionLabel(currency: ICurrency) {
    if (this.labelType === CURRENCY_LABEL.CODE_AND_NAME) {
      return `<span class="has-text-grey-light">${currency.code}</span> - ${currency.name}`;
    }
    if (this.labelType === CURRENCY_LABEL.CODE) {
      return currency.code;
    }
    return currency.name;
  }

  public getValueLabel(currency: ICurrency) {
    return `${currency.name} - <span class="has-text-grey-light">${currency.prefix}${currency.suffix}</span>`;
  }
}
